import { render, staticRenderFns } from "./LoginCardPasswordSettings.vue?vue&type=template&id=33566dd2&scoped=true&"
import script from "./LoginCardPasswordSettings.vue?vue&type=script&lang=js&"
export * from "./LoginCardPasswordSettings.vue?vue&type=script&lang=js&"
import style0 from "./LoginCardPasswordSettings.vue?vue&type=style&index=0&id=33566dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33566dd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VCardText,VContainer,VProgressCircular})
